import DropCheck from 'Components/nui/form/DropCheck';
import { FormattedMessage, useIntl } from 'react-intl';
import { Form } from 'Components/nui';

export const ProductTagsFilter = ({
  allHasTags,
  productGroupChoices,
  setProductGroupChoices,
  tags,
}) => {
  const { formatMessage } = useIntl();
  const name = 'tags';

  if (tags.length === 0) {
    return <></>;
  }

  const theOptions = tags.map((item) => [item.id, item.name]);

  if (!allHasTags) {
    theOptions.push([
      'ungrouped',
      formatMessage({
        id: 'orderform-field-productgroups-others-label',
        defaultMessage: 'Others',
      }),
    ]);
  }

  return (
    <>
      <div className="ant-col ant-form-item-label">
        <label htmlFor={name} className="ant-form-item-required">
          <FormattedMessage
            id="orderform-field-productgroups-label"
            defaultMessage="Product groups"
          />
        </label>
      </div>
      <Form.Item required={true}>
        <DropCheck
          name={name}
          title={formatMessage({
            id: 'orderform-field-productgroups-all-label',
            defaultMessage: 'All',
          })}
          options={theOptions}
          value={productGroupChoices}
          onChange={(_, values) => {
            setProductGroupChoices(values);
          }}
        />
      </Form.Item>
    </>
  );
};
